import React from "react";

// Kaart met de gedeelde kaartradius (--radius-card, 14px).
export default function Card({ className = "", style, children }) {
  return (
    <div className={`card ${className}`.trim()} style={{ borderRadius: "var(--radius-card)", ...style }}>
      {children}
    </div>
  );
}
